import { defineComponent } from 'vue';
import httpClient from '@/services/api/axios';
import index from 'vuex';
export default defineComponent({
    name: 'product-description-entry-garantie',
    computed: {
        index() {
            return index;
        },
    },
    props: {
        title: String,
        content: String,
    },
    data() {
        return {
            expanded: false,
            categories: [],
        };
    },
    methods: {
        toggleExpansion() {
            this.expanded = !this.expanded;
        },
    },
    mounted() {
        httpClient.get('api/blue/product/topLevelCategories').then((response) => {
            this.categories = response.data;
        });
    },
});
